var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collectionOrId)?_c('modal',{staticClass:"details-modal modal-md",attrs:{"id":_vm.modalIdSave,"title":_vm.$i18n.t('saved_searches'),"show-header":true}},[_c('saved-filter',{on:{"load-list-filter":_vm.loadFilter}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }